import React from "react";
import CashMetricReport from "../components/CashMetricReport";

export default function TargetCashReportPage() {
  return (
    <CashMetricReport
      title="Target Cash Report"
      endpoint="/advance-reports/target-cash"
      exportEndpoint="/advance-reports/target-cash/export"
      metricKey="targetCash"
      metricLabel="Target Cash"
      totalsKey="totalTargetCash"
      csvFilename="target-cash-report.csv"
    />
  );
}
